"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downexInstructions4 = exports.downexInstructions3 = exports.downexInstructions5 = exports.downexInstructions2 = exports.downexInstructions1 = exports.instructions = exports.instructionData = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const helpers_2 = require("../../shared/helpers");
const pulseOkButton_1 = require("../../shared/helpers/pulseOkButton");
let startTime;
exports.instructionData = [
    {
        prompt: 'matrixReasoningInstruct1',
        image: 'matrixExample', // GIF?
        buttonText: 'continueButtonText',
    },
];
const replayButtonHtmlId = 'replay-btn-revisited';
let cycleId = 0; // disable audio if the trial has changed since the loop started - prevent overlapping audio
exports.instructions = exports.instructionData.map((data) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            const imageSrc = __1.mediaAssets.images[data.image];
            return `<div class="lev-stimulus-container">
                        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                        <div class="lev-row-container instruction-small">
                            <p>${t[data.prompt]}</p>
                        </div>

                         <div class="lev-stim-content-x-3">
                          <img
                              src=${imageSrc}
                              alt="Image not loading: ${imageSrc}. Please continue the task."
                          />
                        </div>
                    </div>`;
        },
        prompt_above_buttons: true,
        button_choices: ['Next'],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return [
                `<button class="primary">
                ${t[data.buttonText]}
            </button>`,
            ];
        },
        keyboard_choices: () => 'NO_KEYS',
        on_load: () => {
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[data.prompt]);
            const pageStateHandler = new helpers_1.PageStateHandler(data.prompt, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
        },
        on_finish: () => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
        },
    };
});
const downexData1 = {
    audio: [
        'matrix-reasoning-instruct1-part1-downex',
        'matrix-reasoning-instruct1-part2-downex',
        'matrix-reasoning-instruct1-part3-downex',
        'matrix-reasoning-instruct1-part4-downex',
    ],
    choices: ['orange-square', 'blue-circle', 'green-star', 'black-triangle'],
    image: 'downexItem1',
};
const downexData3 = {
    audio: [
        'matrix-reasoning-prompt1-part1-downex',
        'matrix-reasoning-instruct5-part1-downex',
        'matrix-reasoning-instruct5-part2-downex',
        'matrix-reasoning-prompt1-part2-downex',
    ],
    choices: ['orange-square', 'blue-circle', 'green-star', 'black-triangle'],
    image: ['downexItem7', 'downexItem7Gif1', 'downexItem7Gif2'],
};
const downexData4 = {
    audio: [
        'matrix-reasoning-instruct2-part1-downex',
        'matrix-reasoning-instruct2-part2-downex',
        'matrix-reasoning-instruct2-part3-downex',
        'matrix-reasoning-instruct2-part4-downex',
        'matrix-reasoning-instruct2-part5-downex',
    ],
    choices: ['matrix-example-rsp1', 'matrix-example-rsp2', 'matrix-example-rsp3', 'black-square'],
    image: ['matrixExampleDownex', 'matrixExampleGif1Downex', 'matrixExampleGif2Downex', 'matrixExampleGif3Downex'],
};
const textOnlyDownexInstructionData = [
    {
        audio: 'matrix-reasoning-instruct4-downex',
    },
    {
        audio: 'matrix-reasoning-instruct3-downex',
    },
];
function enableOkBtn() {
    const okButton = document.querySelector('.primary');
    if (okButton != null) {
        okButton.disabled = false;
    }
}
exports.downexInstructions1 = {
    type: plugin_html_multi_response_1.default,
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        const stimImage = __1.mediaAssets.images[downexData1.image];
        const itemText = downexData1.audio.map((file) => t[(0, helpers_1.camelize)(file)]).join(' ');
        return `<div class="lev-stimulus-container">
                  ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                  <div class="lev-row-container instruction-small">
                      <p>${itemText}</p>
                  </div>

                  <div id="stim-container" class="lev-stim-content-x-2">
                    <img
                        src=${stimImage}
                        alt="Image not loading: ${stimImage}. Please continue the task."
                    />
                  </div>

                  <div id="choices-container" class="lev-response-row multi-4" style="gap: 16px; margin-top: 16px">
                    <button id="target" class="image no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(downexData1.choices[0])]} alt=${downexData1.choices[0]} />
                    </button>
                    <button class="image no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(downexData1.choices[1])]} alt=${downexData1.choices[1]} />
                    </button>
                    <button class="image no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(downexData1.choices[2])]} alt=${downexData1.choices[2]} />
                    </button>
                    <button class="image no-pointer-events" disabled>
                      <img src=${__1.mediaAssets.images[(0, helpers_1.camelize)(downexData1.choices[3])]} alt=${downexData1.choices[3]} />
                    </button>
                  </div>
              </div>`;
    },
    prompt_above_buttons: true,
    button_choices: ['Next'],
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return [`<button class="primary" disabled>${t.continueButtonText}</button>`];
    },
    keyboard_choices: () => 'NO_KEYS',
    on_load: async () => {
        startTime = performance.now();
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
        // set up replay audio
        const trialAudio = downexData1.audio;
        const replayButton = document.getElementById(replayButtonHtmlId);
        if (replayButton) {
            replayButton.addEventListener('click', () => {
                // clean up from previous animation
                const animatedTarget = document.getElementById('animated-target');
                if (animatedTarget) {
                    animatedTarget.remove();
                }
                target === null || target === void 0 ? void 0 : target.classList.remove('image-grayed-out');
                animateAndPlayAudio();
            });
        }
        const stimContainer = document.getElementById('stim-container');
        const stimImage = stimContainer === null || stimContainer === void 0 ? void 0 : stimContainer.querySelector('img');
        const buttonContainer = document.getElementById('choices-container');
        const buttons = Array.from((buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.querySelectorAll('button')) || []);
        const target = document.getElementById('target');
        async function animateAndPlayAudio() {
            cycleId++;
            const thisCycleId = cycleId;
            // replay button should be disabled while animations are happening
            if (replayButton) {
                replayButton.disabled = true;
            }
            // reset target button to its original position
            if (target) {
                target.style.position = '';
                target.style.left = '';
                target.style.top = '';
                target.style.zIndex = '';
            }
            (0, helpers_1.disableOkButton)();
            // set up animations
            let itemsToAnimate = [target, buttons, stimImage];
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
            };
            for (const [index, audioFile] of trialAudio.slice(0, -1).entries()) {
                const audioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)] || __1.mediaAssets.audio.nullAudio;
                const delay = index === 2 ? 2 : 0;
                if (thisCycleId !== cycleId || (0, taskStore_1.taskStore)().isPaused) {
                    break;
                }
                await new Promise((resolve) => {
                    const configWithCallback = {
                        ...audioConfig,
                        onEnded: () => {
                            setTimeout(() => resolve(), 2000);
                        },
                    };
                    itemsToAnimate = (0, helpers_2.popAnimation)(itemsToAnimate, `pulse 2s ${delay}s 2`);
                    helpers_1.PageAudioHandler.playAudio(audioUri, configWithCallback);
                });
            }
            const lastAudioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(trialAudio[trialAudio.length - 1])] || __1.mediaAssets.audio.nullAudio;
            // animate the target button to the center of stimImage
            if (stimImage && target && !(0, taskStore_1.taskStore)().isPaused && thisCycleId === cycleId) {
                (0, helpers_2.displaceAnimation)(stimImage, target, 'origin', 0.5, 0.5, true);
                const lastAudioConfig = {
                    restrictRepetition: {
                        enabled: false,
                        maxRepetitions: 2,
                    },
                    onEnded: () => {
                        enableOkBtn();
                        if (replayButton) {
                            replayButton.disabled = false;
                        }
                        (0, pulseOkButton_1.pulseOkButton)(6000, (0, taskStore_1.taskStore)().totalTrialCount);
                    },
                };
                setTimeout(() => (!(0, taskStore_1.taskStore)().isPaused ? helpers_1.PageAudioHandler.playAudio(lastAudioUri, lastAudioConfig) : null), 5000);
            }
            else {
                if (replayButton) {
                    replayButton.disabled = false;
                }
            }
        }
        animateAndPlayAudio();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode(); // stop ongoing audio
        cycleId++; // stop queued audio
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            assessment_stage: 'instructions',
        });
    },
};
const textOnlyDownexInstruction = textOnlyDownexInstructionData.map((data) => {
    return {
        type: plugin_html_multi_response_1.default,
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            const itemText = t[(0, helpers_1.camelize)(data.audio)];
            return `
      <div class="lev-stimulus-container">
        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
        <div class="lev-row-container instruction">
          <p>${itemText}</p>
        </div>
      </div>
    `;
        },
        prompt_above_buttons: true,
        button_choices: ['Next'],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return [`<button class="primary" disabled>${t.continueButtonText}</button>`];
        },
        keyboard_choices: () => 'NO_KEYS',
        on_load: () => {
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
                onEnded: () => {
                    enableOkBtn();
                    (0, pulseOkButton_1.pulseOkButton)(3000, (0, taskStore_1.taskStore)().totalTrialCount);
                },
            };
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[(0, helpers_1.camelize)(data.audio)], audioConfig);
            const pageStateHandler = new helpers_1.PageStateHandler(data.audio, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
        },
        on_finish: () => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
        },
    };
});
exports.downexInstructions2 = textOnlyDownexInstruction[0];
exports.downexInstructions5 = textOnlyDownexInstruction[1];
exports.downexInstructions3 = {
    type: plugin_html_multi_response_1.default,
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        const itemText = downexData3.audio.map((file) => t[(0, helpers_1.camelize)(file)]).join(' ');
        return `<div class="lev-stimulus-container">
                  ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                  <div class="lev-row-container instruction-small">
                      <p>${itemText}</p>
                  </div>

                  <div id="stim-container" class="lev-stim-content-x-2">
                    <img
                        id="stim-image"
                        src=${__1.mediaAssets.images[downexData3.image[0]]}
                        alt="Image not loading: ${__1.mediaAssets.images[downexData3.image[0]]}. Please continue the task."
                    />
                  </div>
              </div>`;
    },
    prompt_above_buttons: true,
    button_choices: () => {
        const choices = downexData3.choices;
        return choices.map((choice) => {
            const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
            return `<img src=${imageUrl} alt=${choice} />`;
        });
    },
    button_html: () => '<button class="image-matrix practice-btn"; disabled>%choice%</button>',
    keyboard_choices: () => 'NO_KEYS',
    on_load: async () => {
        startTime = performance.now();
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
        // set up replay audio
        const trialAudio = downexData3.audio;
        const replayButton = document.getElementById(replayButtonHtmlId);
        if (replayButton) {
            replayButton.addEventListener('click', () => {
                animateAndPlayAudio();
            });
        }
        const stimContainer = document.getElementById('stim-container');
        // set up practice button listeners
        const incorrectPracticeResponses = [];
        (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        const buttons = Array.from((buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.querySelectorAll('button')) || []);
        const rspImages = buttons.map((button) => button.querySelector('img'));
        const targetImageIdx = rspImages.findIndex((image) => (image === null || image === void 0 ? void 0 : image.alt) === downexData3.choices[1]);
        let targetButton;
        if (targetImageIdx !== -1) {
            targetButton = buttons[targetImageIdx];
        }
        function onCorrect() {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackRightOne);
        }
        function onIncorrect() {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            if (targetButton) {
                targetButton.style.animation = 'none';
                targetButton.offsetHeight; // Force reflow
                targetButton.style.animation = 'pulse 2s 0s 2';
            }
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.matrixReasoningFeedbackIncorrectDownex);
        }
        (0, helpers_1.addPracticeButtonListeners)(downexData3.choices[1], taskSetup_1.isTouchScreen, downexData3.choices, onCorrect, onIncorrect);
        async function animateAndPlayAudio() {
            cycleId++;
            const thisCycleId = cycleId;
            // replay button should be disabled while animations are happening
            if (replayButton) {
                replayButton.disabled = true;
            }
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
            };
            // switch the stim image after each audio file to highlight each set of items
            for (const [index, audioFile] of trialAudio.entries()) {
                const audioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)];
                const image = index > 2 ? downexData3.image[0] : downexData3.image[index]; // keep the image after the fourth audio file
                if (thisCycleId !== cycleId || (0, taskStore_1.taskStore)().isPaused) {
                    break;
                }
                await new Promise((resolve) => {
                    const configWithCallback = {
                        ...audioConfig,
                        onEnded: () => {
                            setTimeout(() => resolve(), 2000);
                        },
                    };
                    if (stimContainer) {
                        stimContainer.innerHTML = `<img 
                      id="stim-image"
                      src=${__1.mediaAssets.images[image]} 
                      alt="Image not loading: ${__1.mediaAssets.images[image]}. Please continue the task." 
                    />`;
                    }
                    if (index === 0) {
                        const stimImage = document.getElementById('stim-image');
                        if (stimImage) {
                            stimImage.style.animation = 'pulse 2s 0s 2';
                        }
                    }
                    if (index === 3) {
                        buttons.forEach((button) => {
                            button.style.animation = 'none';
                            button.offsetHeight; // Force reflow
                            button.style.animation = 'pulse 2s 0s 2';
                        });
                    }
                    helpers_1.PageAudioHandler.playAudio(audioUri, configWithCallback);
                });
            }
            if (replayButton) {
                replayButton.disabled = false;
            }
            (0, helpers_2.enableAllButtons)();
        }
        animateAndPlayAudio();
    },
    response_ends_trial: false,
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        cycleId++;
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            assessment_stage: 'practice_response',
        });
    },
};
exports.downexInstructions4 = {
    type: plugin_html_multi_response_1.default,
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        const itemText = downexData4.audio.map((file) => t[(0, helpers_1.camelize)(file)]).join(' ');
        return `<div class="lev-stimulus-container">
                  ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                  <div class="lev-row-container instruction-small">
                      <p>${itemText}</p>
                  </div>

                  <div id="stim-container" class="lev-stim-content-x-3">
                    <img
                        src=${__1.mediaAssets.images[downexData4.image[0]]}
                        alt="Image not loading: ${__1.mediaAssets.images[downexData4.image[0]]}. Please continue the task."
                    />
                  </div>
              </div>`;
    },
    prompt_above_buttons: true,
    button_choices: () => {
        const choices = downexData4.choices;
        return choices.map((choice) => {
            const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
            return `<img src=${imageUrl} alt=${choice} />`;
        });
    },
    button_html: () => '<button class="image-matrix practice-btn" disabled>%choice%</button>',
    keyboard_choices: () => 'NO_KEYS',
    on_load: async () => {
        startTime = performance.now();
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
        // set up replay audio
        const trialAudio = downexData4.audio;
        const replayButton = document.getElementById(replayButtonHtmlId);
        if (replayButton) {
            replayButton.addEventListener('click', () => {
                animateAndPlayAudio();
            });
        }
        const stimContainer = document.getElementById('stim-container');
        // set up practice button listeners
        const incorrectPracticeResponses = [];
        (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        const buttons = Array.from((buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.querySelectorAll('button')) || []);
        const rspImages = buttons.map((button) => button.querySelector('img'));
        const targetImageIdx = rspImages.findIndex((image) => (image === null || image === void 0 ? void 0 : image.alt) === downexData4.choices[2]);
        let targetButton;
        if (targetImageIdx !== -1) {
            targetButton = buttons[targetImageIdx];
        }
        function onCorrect() {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackRightOne);
        }
        function onIncorrect() {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            if (targetButton) {
                targetButton.style.animation = 'none';
                targetButton.offsetHeight; // Force reflow
                targetButton.style.animation = 'pulse 2s 0s 2';
            }
            helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.matrixReasoningFeedbackSmBlueDownex);
        }
        (0, helpers_1.addPracticeButtonListeners)(downexData4.choices[2], taskSetup_1.isTouchScreen, downexData4.choices, onCorrect, onIncorrect);
        async function animateAndPlayAudio() {
            cycleId++;
            const thisCycleId = cycleId;
            // replay button should be disabled while animations are happening
            if (replayButton) {
                replayButton.disabled = true;
            }
            const audioConfig = {
                restrictRepetition: {
                    enabled: false,
                    maxRepetitions: 2,
                },
            };
            // switch the stim image after each audio file to highlight each set of items
            for (const [index, audioFile] of trialAudio.entries()) {
                const audioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)];
                const image = index > 3 ? downexData4.image[0] : downexData4.image[index]; // keep the image after the fourth audio file
                if (thisCycleId !== cycleId || (0, taskStore_1.taskStore)().isPaused) {
                    break;
                }
                await new Promise((resolve) => {
                    const configWithCallback = {
                        ...audioConfig,
                        onEnded: () => {
                            setTimeout(() => resolve());
                        },
                    };
                    if (index === 4) {
                        buttons.forEach((button) => (button.style.animation = 'pulse 2s 0s 3'));
                    }
                    if (stimContainer) {
                        stimContainer.innerHTML = `<img 
                      src=${__1.mediaAssets.images[image]} 
                      alt="Image not loading: ${__1.mediaAssets.images[image]}. Please continue the task." 
                    />`;
                    }
                    helpers_1.PageAudioHandler.playAudio(audioUri, configWithCallback);
                });
            }
            if (replayButton) {
                replayButton.disabled = false;
            }
            (0, helpers_2.enableAllButtons)();
        }
        animateAndPlayAudio();
    },
    response_ends_trial: false,
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
        cycleId++;
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            assessment_stage: 'practice_response',
        });
    },
};
